import { Drawer } from '../../common/_drawer.es6';
import Modal from './_modal';

export function main() {
    this.modal = new Modal();

    const status = {
        active: null,
    };
    const targets = document.querySelectorAll('[data-drawer]');
    targets.forEach((el) => {
        const drawer = new Drawer(el, status);
    });

    // アンカーリンクのためヘッダーの高さを取得
    const headerH = document.querySelector('.l-header').getBoundingClientRect().height;
    document.querySelector('html').style.setProperty('--header-h', `${headerH}px`);
}
